import {
  FormControl, InputLabel, MenuItem, Select,
} from '@mui/material';
import { useTranslation } from '../../common/components/LocalizationProvider';
import { usePremiumTokens } from '../../common/theme/usePremiumTokens';
import useReportStyles from '../common/useReportStyles';

const ColumnSelect = ({
  columns, setColumns, columnsArray, rawValues, disabled,
}) => {
  const { classes } = useReportStyles();
  const t = useTranslation();
  const tokens = usePremiumTokens();

  // Premium input styles using tokens
  const formControlSx = {
    minWidth: 240,
    '& .MuiOutlinedInput-root': {
      backgroundColor: tokens.surface.elevated,
      borderRadius: tokens.radius.md,
      transition: tokens.transitions.all,
      '& fieldset': { borderColor: tokens.border.default },
      '&:hover fieldset': { borderColor: tokens.accent.primary },
      '&.Mui-focused fieldset': { borderColor: tokens.accent.primary, borderWidth: 2 },
    },
    '& .MuiInputLabel-root': {
      color: tokens.text.secondary,
      '&.Mui-focused': { color: tokens.accent.primary },
    },
  };

  const selectSx = { backgroundColor: tokens.surface.elevated };

  return (
    <div className={classes.filterItem}>
      <FormControl fullWidth size="small" variant="outlined" sx={formControlSx}>
        <InputLabel>{t('sharedColumns')}</InputLabel>
        <Select
          size="small"
          sx={selectSx}
          label={t('sharedColumns')}
          value={columns}
          onChange={(e) => setColumns(e.target.value)}
          multiple
          disabled={disabled}
        >
          {columnsArray.map(([key, string]) => (
            <MenuItem key={key} value={key}>{rawValues ? string : t(string)}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ColumnSelect;
